import { render, staticRenderFns } from "./StudentNoteItem.vue?vue&type=template&id=217ed44f&scoped=true&"
import script from "./StudentNoteItem.vue?vue&type=script&lang=js&"
export * from "./StudentNoteItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentNoteItem.vue?vue&type=style&index=0&id=217ed44f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ed44f",
  null
  
)

export default component.exports